<template>
  <!--MAIN DIV  -->
  <div class="flex gap-2 overflow-hidden p-2 flex-grow">

    <TRTable :dataRows="dataRows" :header="header">
      <template #cell="{ row, field }">
        <div v-if="field === 'action'">
          <button v-for="action in row['actions']" class="rounded-xl p-1 border w-[100px] hover:bg-white ">
            {{ action.title }}
          </button>
        </div>
        <div v-else class="overflow-hidden whitespace-nowrap text-ellipsis " v-html="formatCellValue(row, field)">
        </div>
      </template>
    </TRTable>

    <!-- Information   -->
    <div class="flex flex-grow w-[300px] bg-trader-dark-gray  flex-shrink-0 rounded">
      <div class="flex flex-col">

        <button @click="windows1" class="">Window 1</button>
        <button @click="windows2" class="">Window 2</button>
        <button @click="windows3" class="">Window 3</button>
        <button @click="windows4" class="">Window 4</button>
        <button @click="windows5" class="">Window 5</button>
        <button @click="windows6" class="">Window 6</button>
        <button @click="windows7" class="">Window 7</button>


      </div>
    </div>
  </div>
</template>


<script setup lang="ts">

import TRTable from "@/components/Base/TRTable.vue";
import {onMounted, ref} from "vue";
import {query} from "@/graphql";
import {electron, ScriptLanguage} from "@/electron";

const selectedRow = ref(-1);


const windows1 = () => {
  electron.openNewWindow("window1", "http://localhost:8101/article/123",{
    modal: true,
  });
}

const windows2 = () => {
  electron.openNewWindow("window2", "http://localhost:8101/article/123",{
    frame: false,
  });
}

const windows3 = () => {
  electron.openNewWindow("window3", "http://localhost:8101/article/123",{
    parent: 'main',
  });
}

const windows4 = () => {
  electron.openNewWindow("window4", "http://localhost:8101/article/123",{
    parent: 'main',
    titleBarStyle: 'default',
  });
}

const windows5 = () => {
  electron.openNewWindow("window5", "http://localhost:8101/article/123",{
    titleBarStyle: 'hidden',
  });
}

const windows6 = () => {
  electron.openNewWindow("window6", "http://localhost:8101/article/123",{
    alwaysOnTop: true,
    height: 400,
    width: 300,
  });
}
const windows7 = () => {
  electron.runScript(ScriptLanguage.JavaScript, `
  windows['window6'].setSize(600,600);
  `);
}



const formatCellValue = (rowData, field) => {
  return rowData[field];
}

const header = ref([
  {
    title: "Name",
    field: "name",
    width: 150,

  }, {
    title: "Beschreibung",
    field: "description",
    width: null,

  }, {
    title: "Version",
    field: "version",
    width: 100,

  }, {
    title: "Aktion",
    field: "action",
    width: 130,

  },
]);


const dataRows = ref([]);

onMounted(async () => {
  const [packages, packagesErr] = await query.getPackages();
  if (packagesErr) {
    console.error("Error loading packages", packagesErr);
  } else {
    dataRows.value = packages;
  }
});


</script>
